import styled from 'styled-components';
import { Drawer } from 'antd';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-footer {
    border: none;
  }
`;
